import { Link } from "@material-ui/core";
import { CSSProperties } from "react";

interface RxLinkProps {
	onClick?: () => void;
	color?:
		| "inherit"
		| "primary"
		| "secondary"
		| "initial"
		| "textPrimary"
		| "textSecondary"
		| "error";
	style?: CSSProperties;
	disabled?: boolean;
	label?: string;
	className?: any;
}

const RxLink = (props: RxLinkProps) => {
	// const isLoading = useSelector((str: any) => str.load.isLoading || false);

	return (
		<Link
			type="button"
			component="button"
			variant="body2"
			disabled={props.disabled}
			onClick={props.onClick}
			style={props.style}
			color={props.color}
			className={props.className}
		>
			{props.label}
		</Link>
	);
};
export default RxLink;
